import { render, staticRenderFns } from "./administratorManagement.vue?vue&type=template&id=693fdeb3&scoped=true"
import script from "./administratorManagement.vue?vue&type=script&lang=js"
export * from "./administratorManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693fdeb3",
  null
  
)

export default component.exports